import React, { useEffect, useState } from "react";
import "./styles/FlashTopBar.css";
import { Button, IconButton } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { Close, PlayArrowRounded, Search } from "@mui/icons-material";
import FilterMenu from "./FilterMenu";

const FlashTopBar = (props) => {
  const navigate = useNavigate();
  const [mobileView, setmobileView] = useState(false);
  const [dynamicCss, setDynamicCss] = useState(80);
  const [localSearch, setLocalSearch] = useState(props.filter.search);

  const filteredCardView =
    props.filter.category !== "" ||
    props.filter.deck !== "" ||
    props.filter.study ||
    props.filter.search !== "";

  // Synchronize local search state if the global filter search changes externally
  useEffect(() => {
    setLocalSearch(props.filter.search);
  }, [props.filter.search]);

  useEffect(() => {
    const url = new URL(window.location.href);
    if (url.pathname === "/flashcards") {
      const isEmpty =
        !props.filter.category &&
        !props.filter.deck &&
        props.filter.study === false &&
        !props.filter.search;

      if (isEmpty) {
        navigate("/flashcards");
        return;
      }

      props.getCards(props.filter);

      const params = new URLSearchParams();
      if (props.filter.deck) params.append("deck", props.filter.deck);
      if (props.filter.category)
        params.append("category", props.filter.category);
      if (props.filter.study) params.append("study", props.filter.study);
      if (props.filter.shuffle) params.append("shuffle", props.filter.shuffle);
      if (props.filter.search) params.append("search", props.filter.search);

      navigate(`${url.pathname}?${params.toString()}`);
    }
    // eslint-disable-next-line
  }, [props.filter]);

  useEffect(() => {
    function handleResize() {
      if (window.innerWidth <= 950) {
        setDynamicCss(125);
        setmobileView(true);
      } else {
        setDynamicCss(80);
        setmobileView(false);
      }
    }
    window.addEventListener("resize", handleResize);
    handleResize();
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [dynamicCss]);

  function handleCategoryChange(e) {
    if (props.filter.category === e.target.value) {
      props.setFilter({ ...props.filter, category: "" });
    } else props.setFilter({ ...props.filter, category: e.target.value });
  }

  function handleDeckChange(e) {
    let newDecks = props.filter.deck !== "" ? props.filter.deck.split(",") : [];
    if (newDecks.includes(e.target.value)) {
      newDecks = newDecks.filter((deck) => deck !== e.target.value);
    } else {
      newDecks.push(e.target.value);
    }
    props.setFilter({ ...props.filter, deck: newDecks.join(",") });
  }

  // Proper form submission handler
  function handleSearchSubmit(e) {
    e.preventDefault();
    props.setFilter({ ...props.filter, search: localSearch });
  }

  return (
    <div className="filter-container">
      <div className="search-bar">
        <form style={{ width: "inherit" }} onSubmit={handleSearchSubmit}>
          <div className="search">
            <input
              type="text"
              id="flash-search-bar"
              placeholder="Search Cards..."
              autoComplete="off"
              list="autocompleteOff"
              value={localSearch}
              disabled={
                props.categories?.length === 0 && props.decks?.length === 0
              }
              onChange={(e) => setLocalSearch(e.target.value)}
            />
            <div className="d-flex justify-center">
              {props.filter.search !== "" ? (
                <IconButton
                  onClick={() => {
                    setLocalSearch("");
                    props.setFilter({ ...props.filter, search: "" });
                  }}
                >
                  <Close fontSize="small" />
                </IconButton>
              ) : (
                <div className="spacer"></div>
              )}
              <IconButton
                type="submit"
                disabled={
                  localSearch === "" ||
                  (props.categories?.length === 0 && props.decks?.length === 0)
                }
              >
                <Search fontSize="small" />
              </IconButton>
            </div>
          </div>
        </form>
        <FilterMenu
          categories={props.categories}
          decks={props.decks}
          filter={props.filter}
          setFilter={props.setFilter}
          handleCategoryChange={handleCategoryChange}
          handleDeckChange={handleDeckChange}
          showPlayButton={filteredCardView}
        />
      </div>
      {!mobileView && filteredCardView && (
        <div className="filter-ctas">
          <Button
            color="green"
            variant="contained"
            disableElevation
            disabled={props.noCardsAvailable}
            className="px-4 ml-2"
            onClick={props.playShuffle}
            endIcon={<PlayArrowRounded color="inherit" />}
          >
            Study Results
          </Button>
        </div>
      )}
    </div>
  );
};

export default FlashTopBar;
